import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { id: "apt-news" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "부동산 월간 리포트"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "매월 정리하는 부동산 시장 동향과 주요 이슈")
], -1)
const _hoisted_3 = { class: "news-layout" }
const _hoisted_4 = { class: "timeline-nav" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "arrow" }
const _hoisted_7 = { class: "month-list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1)
const _hoisted_10 = { class: "month-text" }
const _hoisted_11 = { class: "month-headline" }
const _hoisted_12 = {
  key: 0,
  class: "news-content"
}
const _hoisted_13 = { class: "content-header" }
const _hoisted_14 = { class: "date-badge" }
const _hoisted_15 = { class: "headline" }
const _hoisted_16 = {
  key: 0,
  class: "article-text",
  style: {"margin-top":"14px"}
}
const _hoisted_17 = { class: "article-body" }
const _hoisted_18 = { class: "article-section" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-icon" }, "📜"),
  /*#__PURE__*/_createTextVNode("부동산 정책 동향")
], -1)
const _hoisted_20 = { class: "article-section" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-icon" }, "📰"),
  /*#__PURE__*/_createTextVNode("주요 이슈")
], -1)
const _hoisted_22 = { class: "article-section" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-icon" }, "🏠"),
  /*#__PURE__*/_createTextVNode("서울 부동산 시장")
], -1)
const _hoisted_24 = { class: "article-text" }
const _hoisted_25 = { class: "article-section" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-icon" }, "🏦"),
  /*#__PURE__*/_createTextVNode("금리 동향")
], -1)
const _hoisted_27 = { class: "article-text" }
const _hoisted_28 = {
  key: 0,
  class: "article-section"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-icon" }, "🏗"),
  /*#__PURE__*/_createTextVNode("재건축·재개발 이슈")
], -1)
const _hoisted_30 = { class: "article-text" }
const _hoisted_31 = {
  key: 1,
  class: "article-section"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-icon" }, "🔮"),
  /*#__PURE__*/_createTextVNode("이달의 전망 및 시사점")
], -1)
const _hoisted_33 = { class: "article-text" }
const _hoisted_34 = { class: "article-nav" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "nav-arrow" }, "←", -1)
const _hoisted_37 = { class: "nav-info" }
const _hoisted_38 = { class: "nav-date" }
const _hoisted_39 = { class: "nav-title" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "nav-info" }
const _hoisted_42 = { class: "nav-date" }
const _hoisted_43 = { class: "nav-title" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "nav-arrow" }, "→", -1)
const _hoisted_45 = { class: "mobile-selector" }
const _hoisted_46 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("aside", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (y) => {
          return (_openBlock(), _createElementBlock("div", {
            key: y,
            class: "year-group"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["year-label", { open: _ctx.expandedYears[y] }]),
              onClick: ($event: any) => (_ctx.toggleYear(y))
            }, [
              _createElementVNode("span", null, _toDisplayString(y) + "년", 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.expandedYears[y] ? '▲' : '▼'), 1)
            ], 10, _hoisted_5),
            _withDirectives(_createElementVNode("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMonthsForYear(y), (m) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: m,
                  class: _normalizeClass({ active: _ctx.selectedYear === y && _ctx.selectedMonth === m }),
                  onClick: ($event: any) => (_ctx.selectMonth(y, m))
                }, [
                  _hoisted_9,
                  _createElementVNode("span", _hoisted_10, _toDisplayString(m) + "월", 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getHeadline(y, m)), 1)
                ], 10, _hoisted_8))
              }), 128))
            ], 512), [
              [_vShow, _ctx.expandedYears[y]]
            ])
          ]))
        }), 128))
      ]),
      (_ctx.currentNews)
        ? (_openBlock(), _createElementBlock("main", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.currentNews.year) + "년 " + _toDisplayString(_ctx.currentNews.month) + "월", 1),
              _createElementVNode("h2", _hoisted_15, _toDisplayString(_ctx.currentNews.headline), 1),
              (_ctx.currentNews.summary)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.currentNews.summary), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("article", _hoisted_17, [
              _createElementVNode("section", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentNews.policy, (p, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(p), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("section", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentNews.issues, (s, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(s), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("section", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.currentNews.seoulMarket), 1)
              ]),
              _createElementVNode("section", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.currentNews.interestRate), 1)
              ]),
              (_ctx.currentNews.reconstruction)
                ? (_openBlock(), _createElementBlock("section", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.currentNews.reconstruction), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.currentNews.outlook)
                ? (_openBlock(), _createElementBlock("section", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.currentNews.outlook), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("button", {
                class: "nav-btn prev",
                disabled: !_ctx.prevNews,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goPrev && _ctx.goPrev(...args)))
              }, [
                (_ctx.prevNews)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_36,
                      _createElementVNode("span", _hoisted_37, [
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.prevNews.year) + "년 " + _toDisplayString(_ctx.prevNews.month) + "월", 1),
                        _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.prevNews.headline), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_35),
              _createElementVNode("button", {
                class: "nav-btn next",
                disabled: !_ctx.nextNews,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goNext && _ctx.goNext(...args)))
              }, [
                (_ctx.nextNews)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.nextNews.year) + "년 " + _toDisplayString(_ctx.nextNews.month) + "월", 1),
                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.nextNews.headline), 1)
                      ]),
                      _hoisted_44
                    ], 64))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_40)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_45, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mobileSelected) = $event)),
        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onMobileSelect && _ctx.onMobileSelect(...args)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedAllNews, (item) => {
          return (_openBlock(), _createElementBlock("option", {
            key: `${item.year}-${item.month}`,
            value: `${item.year}-${item.month}`
          }, _toDisplayString(item.year) + "년 " + _toDisplayString(item.month) + "월 - " + _toDisplayString(item.headline), 9, _hoisted_46))
        }), 128))
      ], 544), [
        [_vModelSelect, _ctx.mobileSelected]
      ])
    ])
  ]))
}